<script lang="ts">
  import { t } from 'svelte-i18n';
  import { setModalHash } from '../shared/modal-store';
  import Button from '../shared/button.svelte';

  export let element: HTMLElement = undefined;

  function openWellabeModal() {
    setModalHash('wellabe');
  }
</script>

<div class="relative flex flex-col bg-wellabe-bg-medium">
  <div
    class="flex justify-center h-screen flex-col pt-[72px] md2:pt-[80px] xl:pt-[104px] md2:flex-row overflow-hidden h-[100vh - 72px] md2:gap-12 lg:gap-20 xl:gap-24"
  >
    <div
      class="flex flex-grow-0 md2:flex-grow md2:flex-1 flex-col justify-center px-[3rem] pt-[3.5rem] pb-14 md2:pb-0 items-center md2:items-start md2:px-[unset] md2:pt-0"
    >
      <div class="flex flex-col justify-center md2:justify-start md2:ml-auto">
        <p
          class="text-wellabe-primary text-center opacity-100 text-xxs leading-[1.5rem] pb-0 md2:text-xl md2:leading-10 md2:text-left"
        >
          {$t('WORK.WELLABE.TITLE')}
        </p>
        <p
          class="text-black text-center opacity-100 text-xxs leading-[1.5rem] md2:text-xl md2:leading-10 md2:text-left w-[262px] xs:w-[266px] sm:w-[328px] md:w-[356px] md2:w-[416px] lg:w-[440px] xl:w-[576px]"
        >
          {$t('WORK.WELLABE.DESCRIPTION')}
        </p>

        <!-- svelte-ignore a11y-missing-attribute -->
        <a
          on:click={openWellabeModal}
          class="cursor-pointer mt-6 pb-1 text-[1rem] md2:mb-16 md2:mt-14 mx-auto md2:mx-0"
        >
          <Button>
            <span>{$t('WORK.VIEW')}</span>
          </Button></a
        >
      </div>
    </div>
    <div
      class="flex flex-1 justify-center pt-0 md2:pt-14 pl-14 sm:pl-[4.5rem] md:pl-[8rem] md2:pl-0"
    >
      <div
        style="background-image: url('images/wellabe-full-img.png'); background-position: top left;"
        class="bg-cover bg-no-repeat w-full sm:min-w-[486px] min-h-full h-auto"
      />
    </div>
  </div>
  <span class="absolute bottom-[72px]" bind:this={element} />
</div>
